/* @flow */

export default class SetBusinessOpportunityRequest {
  leadId: number;
  financingNeedId: number;
  financingNeedFrequencyId: number;
  invoicesAvgAmountId: number;
  invoicesYearlyAmountId: number;
}
